import { GdprReportsRepository } from 'common/repositories/index';

const _serviceDependencies = ['$scope', '$state', 'GdprReportsRestService', 'Util'];

class PrintGDPRReport {

    constructor($scope, $state, GdprReportsRestService, Util) {

        $scope.brandName = CWCONFIG.partnerConfig.name;

        angular.element('body').addClass('print-page');

        setTimeout(() => {

            angular.element('body').removeClass('dark');

        }, 0);

        GdprReportsRestService.getAllAsync().then((response) => {

            if (response.data.data.length > 0) {

                response.data.data.forEach((report) => {


                    const gdprReportTimestamp = Util.deepFind(report, 'attributes.report_received_timestamp');

                    if (gdprReportTimestamp) {

                        $scope.gdprReportTimestamp = moment(gdprReportTimestamp).format('L');

                    }

                    const finalReport = Util.deepFind(report, 'attributes.final_report');

                    if (finalReport) {

                        GdprReportsRepository.add(JSON.parse(finalReport));
                        $scope.hasReport = true;
                        $scope.finalReport = GdprReportsRepository.getAll();

                        setTimeout(() => {

                            window.print();

                        }, 500);

                    } else {

                        $state.go('root.dashboard.my-account', {
                            tab: 'data-settings',
                        }, {
                            reload: true,
                        });

                    }

                });

            } else {

                $state.go('root.dashboard.my-account', {
                    tab: 'data-settings',
                }, {
                    reload: true,
                });

            }

        }).catch(() => {

            $state.go('root.dashboard.my-account', {
                tab: 'data-settings',
            }, {
                reload: true,
            });

        });

        $scope.print = () => {

            window.print();

        };

    }

}

_serviceDependencies.push(PrintGDPRReport);

angular.module('controllers')
    .controller('PrintGDPRReport', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/print-gdpr-report/print-gdpr-report.js